
<div class="row" :class="[jel_getClassObject(content)]">
  <EditableArea
    v-if="mixinEnvironnement_inEditor"
    :content="content.salles"
    :parentTemplateId="metadata['mgnl:template']"
    class="w-100 h-100"
  />
  <div v-else class="overlay w-100">
    <div class="w-100 h-100">
      <Heritage :content="contentBanniereLaterale" />
    </div>
    <div v-if="indAfficherListeSalle" class="d-none d-lg-block">
      <div>
        <b-row :data-component-name="$options.name">
          <b-col
            md="6"
            offset-md="6"
            lg="5"
            offset-lg="7"
            xl="4"
            offset-xl="8"
            class="overlay_background col-xxl-3 offset-xxl-9 px-0"
          >
            <div class="d-flex justify-content-end mb-1">
              <button
                class="fermerSalle ctn-shadow overlay_btn_taille_fixe btn d-flex align-items-center justify-content-center graphik_semibold py-1"
                @click="indAfficherListeSalle = !indAfficherListeSalle"
              >
                <div class="pr-1">{{ content.txtFermer }}</div>
                <img
                  :src="`${mixinEnvironnement_damPath}/jel/bingo/icones/icon_closeLobby.svg`"
                  class="close_menu_icon"
                  alt="close-menu"
                />
              </button>
            </div>
            <div class="overlay_content">
              <template v-for="aNode in content.salles['@nodes']">
                <b-col
                  v-if="content.salles[aNode]['idSalle'] !== idSalleCourante"
                  :key="aNode"
                  class="px-4"
                >
                  <BingoSalle class="py-1" :content="content.salles[aNode]"> </BingoSalle>
                </b-col>
              </template>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div v-else class="changerSalle d-none d-lg-flex">
      <button
        class="btn btn_bingo_theme overlay_btn_taille_fixe btn_changer_salle graphik_semibold ctn-shadow"
        @click="indAfficherListeSalle = !indAfficherListeSalle"
      >
        <div>
          {{ content.txtChangerSalle }}
          <img
            v-lazy="
              `${mixinEnvironnement_damPath}/jel/bingo/clavardage/animateurs/ic_fleche_animateur_down.svg`
            "
            class="height_arrow"
            :alt="content.txtChangerSalle"
          />
        </div>
      </button>
    </div>
  </div>

  <div v-if="salles && !mixinEnvironnement_inMgnl">
    <iframe :src="iFrameURL" title="iFrame Bingo"></iframe>
  </div>
</div>
